export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/opponents`;
}

export function CreateClub(organizationID: number): string {
	return `/v1/organizations/${organizationID}/opponents/clubs`;
}

export function CreatePlayer(organizationID: number): string {
	return `/v1/organizations/${organizationID}/opponents/players`;
}

export function Delete(organizationID: number, opponentID: number): string {
	return `/v1/organizations/${organizationID}/opponents/${opponentID}`;
}

export function DeleteClub(organizationID: number, opponentID: number): string {
	return `/v1/organizations/${organizationID}/opponents/clubs/${opponentID}`;
}

export function DeletePlayer(organizationID: number, opponentPlayerID: number): string {
	return `/v1/organizations/${organizationID}/opponents/players/${opponentPlayerID}`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/opponents`;
}

export function IndexTable(organizationID: number): string {
	return `/v1/organizations/${organizationID}/opponents/table`;
}

export function Merge(organizationID: number): string {
	return `/v1/organizations/${organizationID}/opponents/merge`;
}

export function Update(organizationID: number, opponentID: number): string {
	return `/v1/organizations/${organizationID}/opponents/${opponentID}`;
}

export function UpdateClub(organizationID: number, opponentID: number): string {
	return `/v1/organizations/${organizationID}/opponents/clubs/${opponentID}`;
}

export function UpdatePlayer(organizationID: number, opponentPlayerID: number): string {
	return `/v1/organizations/${organizationID}/opponents/players/${opponentPlayerID}`;
}

